import { SearchNormal, Calendar } from "iconsax-react";

export const CMSFilterBar = ({
  searchQuery,
  onSearchChange,
  searchPlaceholder = "Search...",
  categories = [],
  selectedCategory,
  onCategoryChange,
  statuses = [],
  selectedStatus,
  onStatusChange,
  showDateFilter = true,
  onDateClick,
}) => {
  return (
    <div className="mb-[22px]">
      <div className="flex flex-col lg:flex-row justify-between gap-3">
        <div className="max-w-[400px] w-full relative h-full">
          <SearchNormal
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-[14px] focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent"
          />
        </div>

        <div className="flex items-center gap-3">
          {categories.length > 0 && (
            <select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-md text-[14px] focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent bg-white cursor-pointer"
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          )}

          {statuses.length > 0 && (
            <select
              value={selectedStatus}
              onChange={(e) => onStatusChange(e.target.value)}
              className="px-4 py-2 border border-dashed border-gray-300 rounded-md text-[14px] focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent bg-white cursor-pointer"
            >
              {statuses.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          )}

          {showDateFilter && (
            <button
              onClick={onDateClick}
              className="px-4 py-2 border border-dashed border-gray-300 rounded-md text-[14px] hover:bg-gray-50 flex items-center gap-2 font-medium transition-all duration-300"
            >
              <Calendar size={18} />
              Date
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
